import script from "./PastPapers.vue?vue&type=script&setup=true&lang=js"
export * from "./PastPapers.vue?vue&type=script&setup=true&lang=js"

import "./PastPapers.vue?vue&type=style&index=0&id=d401ba1a&scoped=true&lang=css"
import "./PastPapers.vue?vue&type=style&index=1&id=d401ba1a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d401ba1a"]])

export default __exports__